import React, { FC, RefObject } from "react";
import { useTranslation } from "react-i18next";
import { OpportunitiesList } from "./OpportunitiesList";
import {
  BUYERS_OPPORTUNITIES_OPTIONS,
  REVOLUTIONIZE_APPROACH_DESCRIPTION_PARAGRAPHS,
  SELLERS_OPPORTUNITIES_OPTIONS,
} from "./constants";
import { revolutionizeApproachTrns } from "../trns";

interface Props {
  sectionRef?: RefObject<HTMLElement>;
}

export const RevolutionizeApproach: FC<Props> = ({ sectionRef }) => {
  const { t } = useTranslation();

  return (
    <section
      className="container flex flex-col gap-8 lg:gap-10 -mt-20 pt-20"
      ref={sectionRef}
    >
      <h3 className="text-purple-base text-center">
        {t(revolutionizeApproachTrns.title)}
      </h3>

      <div className="flex flex-col lg:flex-row items-start gap-15">
        <OpportunitiesList
          className="flex-1"
          options={BUYERS_OPPORTUNITIES_OPTIONS}
          title={"Buyers"}
        />
        <OpportunitiesList
          className="flex-1"
          options={SELLERS_OPPORTUNITIES_OPTIONS}
          title={"Sellers"}
        />
      </div>

      <div className="flex flex-col gap-5 text-blue-dark text-justify">
        {REVOLUTIONIZE_APPROACH_DESCRIPTION_PARAGRAPHS.map((paragaph) => (
          <p key={paragaph.id}>{t(paragaph.text.i18nKey)}</p>
        ))}
      </div>
    </section>
  );
};
